// Simple global settings storage
export const FlowBuilderSettings = {
  jwt: "",
  modelId: "",
  backendENV: "",
  onModeChange: undefined as (() => void) | undefined,
  demoMode: false,
  minimapEnabled: true,
  demoData: undefined as {nodes: any[]; edges: any[]} | undefined,
};
